import {
  Alert,
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useRef } from "react";
import {
  initInstitutionSlice,
  setPropertiesInstitution,
  updateInstitution,
} from "../Slices/Institution.slice";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { institutionsDetailinputs } from "./InstitutionDetailForm";
import { InstitutionHeader } from "../../../shared/components/InstitutionHeader/InstitutionHeader";
import { http } from "../../../engine/api/http";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";

const { Content, Sider, Header, Footer } = Layout;

export function InstitutionDetail({ unitId, expanded, onClose }) {
  // Upsert

  //  Update Insert

  // entity.upsert.js

  const { id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);

  const { init, clear } = initInstitutionSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const m2Exposant = (
    <span>
      m<sup>2</sup>
    </span>
  );

  const inputs = institutionsDetailinputs({ institution, formRef });

  const onSubmitForm = async data => {
    if (formRef.current._billings !== undefined) {
      data.billings = formRef.current._billings;
    }

    await dispatch(setPropertiesInstitution(data));
    dispatch(updateInstitution());
  };

  return (
    <>
      <InstitutionHeader title={routes.institutions(id).detail.title} />
      {!loading && institution?.mergedInto && (
        <Alert
          type="warning"
          showIcon
          style={{ margin: "0 24px 16px" }}
          message={
            <span>
              Cette institution a été fusionnée dans{" "}
              <Link
                to={
                  routes.institutions(
                    institution.mergedInto._id || institution.mergedInto,
                  ).detail.path
                }
              >
                {institution.mergedInto.name || "la nouvelle institution"}
              </Link>
              {institution.mergedAt
                ? ` le ${new Date(institution.mergedAt).toLocaleDateString(
                    "fr-CH",
                  )}`
                : ""}
              . Ses prestations, factures, adresses et utilisateurs s'y trouvent
              désormais.
            </span>
          }
          // no automatic redirect: this archived page stays reachable for the history
          action={
            <Link
              to={
                routes.institutions(
                  institution.mergedInto._id || institution.mergedInto,
                ).detail.path
              }
            >
              <Button type="primary">
                Aller à{" "}
                {institution.mergedInto.name || "la nouvelle institution"}
              </Button>
            </Link>
          }
        />
      )}
      {loading ? (
        <Skeleton active />
      ) : (
        <CustomForm
          rule={routes.institutions(id).detail}
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      )}
    </>
  );
}
